/**
 * The team member card's own words — ONE copy, read by today's card (src/components/TeamMemberCard.tsx) and the team
 * page's rebuild in the new design (design record §7b, rule 1). The people themselves (names, roles, bios, links,
 * Prest0n's output feed) are src/data/teamMembers.ts, shared the same way.
 *
 * The feed's title and its lead each write prest0's zero as the mark, so each is two pieces around it.
 */
export const TEAM_MEMBER_CARD_WORDS = {
  cofounder: 'co-founder',
  achievements: 'view achievements',
  linkedin: 'linkedin',
  /** "Prest" + the mark as its 0 + "n — Output Feed". */
  feedTitle: { before: 'Prest', after: 'n — Output Feed' },
  /** The zero in the title and the lead, for someone who cannot see the mark. */
  zero: '0',
  /** "A running log … for the prest" + the mark as its 0 + " platform:". */
  feedLead: { before: 'A running log of infrastructure, product, and code shipped autonomously for the prest', after: ' platform:' },
} as const;
